import { FunctionComponent, useEffect, useState } from "react";
import { Col, Form, Row } from "antd";
import {
  formValidateTriggers,
  MAX_LENGTH_TRANSACTION_MODEL_NAME,
} from "@utils/Constant";
import SubmitButton from "@components/core/buttons/SubmitButton";
import InputFormField from "@components/core/inputs/InputFormField";
import { useForm } from "antd/lib/form/Form";
import { setCurrentTransactionField } from "@/state/transactions/CurrentTransactionEvents";

interface OfficeChoiceSectionProps {
  className?: string;
  onSubmit: () => void;
  name?: string;
}

const ModelNameSection: FunctionComponent<OfficeChoiceSectionProps> = ({
  className = "",
  onSubmit,
  name,
}) => {
  const [form] = useForm();
  const [submittable, setSubmittable] = useState(false);

  const values = Form.useWatch([], form);

  useEffect(() => {
    if (form.getFieldValue("input") !== "") {
      setCurrentTransactionField([
        {
          field: "name",
          value: form.getFieldValue("input"),
        },
      ]);
      setSubmittable(true);
    } else {
      setSubmittable(false);
    }
  }, [form, values]);

  const InitialValues = {
    input: name,
  };

  const handleSubmit = () => {
    onSubmit();
  };

  return (
    <Row
      className={`app-section-model-name justify-content-center ${className}`}
    >
      <Col span={24} lg={20} xl={16}>
        <Form
          form={form}
          onFinish={handleSubmit}
          initialValues={InitialValues}
          {...formValidateTriggers}
          layout="vertical"
        >
          <InputFormField
            showLabel
            showTooltip
            labelTooltip="modelName"
            module="offices.transactionModel"
            field="input"
            maxLength={MAX_LENGTH_TRANSACTION_MODEL_NAME}
          />
          <div className="d-flex align-items-center justify-content-end pt-30">
            <SubmitButton
              disabled={!submittable}
              label={"buttons.next"}
              className="mw-160"
            />
          </div>
        </Form>
      </Col>
    </Row>
  );
};

export default ModelNameSection;
